export const pointStatus = [
    {
        value: 'WITHDRAWAL_REQUEST',
        name: '출금신청'
    },
    {
        value: 'WITHDRAWCANCEL',
        name: '출금취소'
    },
    {
        value: 'BID_DIGITAL',
        name: '디지털 아이템 입찰'
    },
    {
        value: 'BID_REAL',
        name: '실물 아이템 입찰'
    },
    {
        value: 'BIDFAIL',
        name: '입찰실패'
    },
    {
        value: 'AUCTION_COMPLETION',
        name: '경매 판매완료'
    },
    {
        value: 'PRICETAG_DIGITAL',
        name: '지정가판매상품 디지털 아이템 구매'
    },
    {
        value: 'PRICETAG_REAL',
        name: '지정가판매상품 실물 아이템 구매'
    },
    {
        value: 'PRICETAG',
        name:'지정가판매상품 판매완료'
    },
    {
        value: 'REALFAIL',
        name: '실물 아이템 거래 관리자 파기'
    },
    {
        value: 'LICENSE_PURCHASE',
        name:'라이선스 구매'
    },
    {
        value: 'LICENSE_SALE',
        name: '라이선스 판매'
    },
    {
        value: 'CURATION_INCENTIVE',
        name: '큐레이터 인센티브'
    },
    {
        value: 'COMPETITION_HOST',
        name: '공모전 주최'
    },
    {
        value: 'COMPETITION_CANCEL',
        name: '공모전 취소'
    },
    {
        value: 'COMPETITION_AWARD',
        name: '공모전 수상'
    },
    {
        value: 'ADMINPLUS',
        name: '관리자 지급'
    },
    {
        value: 'ADMINMINUS',
        name: '관리자 차감'
    },
    {
        value: 'DETECT',
        name: '아이템 검출'
    },
    {
        value: 'DETECT_FAIL',
        name: '아이템 검출 실패'
    },
    {
        value: 'CHARGE_CANCEL',
        name: '충전 취소'
    },
    {
        value: 'CHARGE',
        name: '충전'
    },
    {
        value: 'JOIN',
        name: '가입'
    },
    {
        value: 'RECOMMAND',
        name: '추천인 입력'
    },
    {
        value: 'GIFT',
        name: '아이템 선물'
    },
    {
        value: 'ROYALTY',
        name: '아이템 로열티'
    },
    {
        value: 'NETWORKFEES',
        name: '네트워크 수수료'
    },
    {
        value: 'FEES',
        name: '수수료'
    },
    {
        value: 'OUT',
        name: '회원 탈퇴'
    },
    {
        value: 'UTILITY_BUY',
        name: '유틸리티 구매'
    },
    {
        value: 'UTILITY_SELL',
        name: '유틸리티 판매'
    },
    {
        value: 'UTILITY_REFUND',
        name: '유틸리티 환불'
    },
    {
        value: 'UTILITY_GIFT',
        name: '유틸리티 선물'
    },
];
export const pointFilterStatus = {
    'auction': {name: ' 경매'},
    'deal': {name: '거래'},
    'contest': {name: '공모전'},
    'mingle': {name: '충전/출금'},
    'etc': {name: '기타'},
    'charge': {name: '충전'},
    /*'utilGift': {name: '유틸리티 선물'},
    'utilBuy': {name: '유틸리티 구매'},
    'utilSell': {name: '유틸리티 판매'},
    'utilRefund': {name: '유틸리티 환불'},*/
};

export const paymentType = {
    10 :{name : '카드'},
    11 :{name : '실시간계좌이체'},
    12 :{name : '가상계좌'},
    13 :{name : '휴다폰결제'},
}

